import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { formatDate } from '@fund/basic-lib/dist/lib/date';
import { numeral } from '@fund/basic-lib/dist/lib/numeral';
import config from '../configs/default';
// 处理资产信息
function handleAssets(data, expansion) {
  if (!data) return { title: '资产', data: [] };
  const keyConfig = {
    JJ: '基金',
    GP: '股票',
    ZQ: '债券',
    HB: '现金',
    QT: '其他',
  };
  const colorConfig = {
    JJ: '#7ABDFF',
    GP: '#FF6933',
    ZQ: '#FFC94D',
    HB: '#D494FF',
    QT: '#E0E0E0',
  };
  let totalValue = 0;
  const mainData = (data[expansion] && data[expansion][0]) ? data[expansion][0] : {};
  const temp = [];
  Object.keys(keyConfig).forEach((element) => {
    if (!isEmpty(mainData[element])) {
      temp.push({
        type: keyConfig[element],
        percent: Number((parseFloat(mainData[element]) / 100).toFixed(4)),
        color: colorConfig[element],
      });
      totalValue += Number(mainData[element]);
    }
  });

  return {
    title: '资产',
    data: [...temp],
    isMoreThanHundred: totalValue > 100,
  };
}

// 处理货币资产
function handleCurrencyAssets(data) {
  if (!data) return { title: '资产', data: [] };
  const keyConfig = {
    BSPCTNV: '债券',
    ABSPCTNV: '资产支持证券',
    BREPOPCTNV: '买入返售金融资产',
    MPCTNV: '银行存款和结算备付金合计',
    OIPCTNV: '其他各项资产',
  };
  const colorConfig = {
    BSPCTNV: '#FFC94D',
    ABSPCTNV: '#4D8EFF',
    BREPOPCTNV: '#E6BAFF',
    MPCTNV: '#FF6933',
    OIPCTNV: '#E0E0E0',
  };
  let totalValue = 0;
  const mainData = data.FundAsset || {};
  const temp = [];
  Object.keys(keyConfig).forEach((element) => {
    if (!isEmpty(mainData[element])) {
      totalValue += Number(mainData[element]);
      temp.push({
        type: keyConfig[element],
        percent: Number((parseFloat(mainData[element]) / 100).toFixed(4)),
        color: colorConfig[element],
      });
    }
  });
  return {
    title: '资产',
    data: [...temp],
    isMoreThanHundred: totalValue > 100,
  };
}

// 处理规模信息
function handleFundSize(data) {
  const formatValue = (value) => {
    if (value) {
      if (value >= 1000000) {
        return `${(value / 100000000).toFixed(2)}亿`;
      } if (value >= 100) {
        return `${(value / 10000).toFixed(2)}万`;
      }
      return value;
    }
    return '--';
  };
  let temp = [];
  if (data && data.length) {
    data.forEach((element) => {
      temp.push({
        date: element.FSRQ,
        type: '基金A',
        value: parseFloat(element.NETNAV),
        title: formatValue(element.NETNAV),
        sizeType: 1,
      });
    });
  }

  if (!temp.length) return [];
  temp.sort((b, a) => Date.parse(a.date.replace(/-/g, '/')) - Date.parse(b.date.replace(/-/g, '/')));
  temp.forEach((item) => {
    // eslint-disable-next-line no-param-reassign
    item.date = item.date.substring(2);
  });
  temp = temp.length >= 4 ? temp.splice(0, 4).reverse() : temp.reverse();
  temp[temp.length - 1].type = '基金B';
  const lastValue = temp[temp.length - 1].value;
  const fundSize = (Number(lastValue) / 100000000).toFixed(2);
  return {
    fundSize,
    data: temp,
  };
}

// 获取净资产和规模 时间 净资产披露时间提示
function handleNetAssetsInfo(data, expansion) {
  if (!data) return {};
  const mainData = data[expansion];
  let netAssetsValue = '--';
  let netAssets = '--';
  // 净资产披露提示
  let netAssetTipText = '';
  // 净资产
  if (mainData && mainData[0]) {
    netAssetsValue = Number(mainData[0].JZC).toFixed(2);
    netAssets = `${Number(mainData[0].JZC).toFixed(2)}亿元`;
  }
  if (data && Object.keys(data).length) {
    // 净资产披露提示
    Object.keys(data).forEach((key) => {
      if (key > expansion) {
        if (data[key].length) {
          const { JZC } = data[key][0];
          const date = formatDate(new Date(key), 'M月dd日');
          netAssetTipText = `${date}披露最新净资产${parseFloat(JZC).toFixed(2)}亿元，未披露持仓明细。`;
        }
      } else if (key < expansion) {
        const { JZC } = data[key][0];
        const date = formatDate(new Date(key), 'yyyy年MM月dd日');
        const time = formatDate(new Date(expansion), 'M月dd日');
        netAssetTipText = `${time}未披露净资产，${date}披露净资产${parseFloat(JZC).toFixed(2)}亿元。`;
      }
    });
  }
  return {
    netAssets: netAssets || '--',
    netAssetsValue,
    netAssetsDate: expansion,
    netAssetTipText,
  };
}

// 分类
function handleClassification(data, expansion) {
  if (!data) return { title: '基金类型', data: [] };
  const keyConfig = {
    '000001': '股票指数',
    '000002': '固收指数',
    '000003': '海外股票指数',
    '000005': '其他',
    '001001': '普通股票',
    '002001': '偏股',
    '002002': '平衡',
    '002003': '偏债',
    '002004': '灵活',
    '002005': '绝对收益',
    '003001': '长债',
    '003002': '中短债',
    '003003': '混合一级',
    '003004': '混合二级',
    '003005': '理财',
    '005001': '普通货币',
    '005002': '浮动净值',
    '007001': '普通股票',
    '007002': '混合偏股',
    '007003': '混合平衡',
    '007004': '混合灵活',
    '007005': '纯债',
    '007006': '混合债',
    '007007': 'REITs',
    '007008': '商品',
    '007009': 'FOF',
    '009001': '进取型',
    '009002': '均衡型',
    '009003': '稳健型',
    205001: '其他',
  };
  const colorList = config.industryColor;
  const mainData = data[expansion] || [];
  const temp = [];
  let totalValue = 0;
  mainData.forEach((element, index) => {
    temp.push({
      type: keyConfig[element.BTYPE],
      percent: Number((parseFloat(element.PCTNV) / 100).toFixed(4)),
      color: colorList[index],
    });
    totalValue += parseFloat(element.PCTNV);
  });
  return {
    title: '基金类型',
    data: temp,
    isMoreThanHundred: totalValue > 100,
  };
}

// 证监会 行业
function handleIndustry(data, expansion) {
  if (!data) return { title: '行业', data: [] };
  const mainData = data[expansion] || [];
  const colorList = config.industryColor;
  let totalValue = 0;
  const temp = [];
  mainData.forEach((element, index) => {
    if (!isEmpty(element.ZJZBL) && element.HYMC !== '合计') {
      temp.push({
        type: element.HYMC,
        percent: parseFloat(element.ZJZBL) / 100,
        color: colorList[index],
      });
      totalValue += element.PCTNV - 0;
    }
  });
  return {
    title: '行业',
    data: temp,
    isMoreThanHundred: totalValue > 100,
  };
}

// 主题
function handleTopic(data, expansion) {
  if (!data) return { title: '行业', data: [] };
  const mainData = data[expansion] || [];
  const colorList = config.industryColor;
  let totalValue = 0;
  const temp = [];
  mainData.forEach((element, index) => {
    if (!isEmpty(element.PCTNV) && element.TOPICCODE !== '合计') {
      temp.push({
        type: element.TOPICCODE,
        percent: Number(Number(parseFloat(element.PCTNV) / 100).toFixed(4)),
        color: colorList[index],
      });
      totalValue += element.PCTNV - 0;
    }
  });
  return {
    title: '行业',
    data: temp,
    isMoreThanHundred: totalValue > 100,
  };
}

// 券种
function handleCouponType(data) {
  if (!data) return { title: '券种', data: [] };
  const keyConfig = {
    1: '信用债',
    2: '利率债',
    3: '可转债',
    4: '其他',
  };
  const colorList = ['#3C6DF7', '#4D8EFF', '#7ABDFF', '#7AD8FF'];
  const temp = [];
  let totalValue = 0;
  data.forEach((element, index) => {
    temp.push({
      type: keyConfig[element.BONDTYPENEW],
      percent: Number((parseFloat(element.PCTNV) / 100).toFixed(4)),
      color: colorList[index],
    });
    totalValue += element.PCTNV;
  });
  return {
    title: '券种',
    data: temp,
    isMoreThanHundred: totalValue > 100,
  };
}

// 重仓股票比例
function handleHeavyStockRatio(data) {
  if (isEmpty(data)) return '--';
  const fundStocks = data.fundStocks || [];
  if (fundStocks && fundStocks.length) {
    let heavyStockRatio = 0;
    fundStocks.forEach((element) => {
      if (element && element.JZBL && element.JZBL !== '--') {
        heavyStockRatio += parseFloat(element.JZBL);
      }
    });
    return heavyStockRatio;
  }
  return '--';
}

// 重仓股票列表
function handleHeavyStockList(data, expansion) {
  const temp = [];
  let allHoldRatio = 0; // 持仓比例
  if (data && data.length) {
    data.forEach((element) => {
      const {
        PCTNVCHGTYPE, JZBL, PCTNVCHG, HOLDCOUNT, GPJC, GPDM, INDEXNAME, NEWTEXCH,
      } = element;
      // 计算持仓比例之和
      allHoldRatio += isEmpty(JZBL) ? 0 : Number(JZBL);
      // 持仓比例
      const holdRatio = isEmpty(JZBL) ? '--' : `${Number(JZBL).toFixed(2)}%`;
      // 较上期比例 新增不变直接展示文字 其他情况展示箭头 + 数字
      const compareWithPrevious = ['新增', '不变'].indexOf(PCTNVCHGTYPE) >= 0
        ? PCTNVCHGTYPE
        : `${parseFloat(PCTNVCHG).toFixed(2)}%`;
      // 连续持有期数
      // eslint-disable-next-line max-len
      const holdCount = isEmpty(HOLDCOUNT) || isEmpty(parseInt(HOLDCOUNT, 10)) || parseInt(HOLDCOUNT, 10) <= 1
        ? '--'
        : `${parseInt(HOLDCOUNT, 10)}季度`;
      // 股票简称 股票代码 指数 新市场编号
      const stockName = GPJC;
      const stockCode = GPDM;
      const indexName = INDEXNAME;
      const newMarketCode = NEWTEXCH;
      temp.push({
        holdRatio,
        compareWithPrevious,
        holdCount,
        stockName,
        stockCode,
        indexName,
        newMarketCode,
        code: stockCode,
      });
    });
    // 取10大重仓
    if (temp.length > 10) {
      temp.splice(10, temp.length - 10);
    }
  }
  return {
    allHoldRatio: isEmpty(allHoldRatio) ? '--' : `${allHoldRatio.toFixed(2)}%`,
    list: temp,
    holdDate: expansion,
  };
}

// 重仓债券列表
function handleHeavyBondList(data, BondInvestDistri, expansion) {
  const temp = [];
  let isShowBondsPrice = false;
  let allHoldRatio = 0; // 持仓比例
  if (data && data.length) {
    const BONDTYPENEWS = BondInvestDistri?.map((item) => item.BONDTYPENEW);
    isShowBondsPrice = BONDTYPENEWS?.indexOf(3) >= 0 || BONDTYPENEWS?.indexOf('3') >= 0;
    data.forEach((element) => {
      const {
        PCTNVCHGTYPE, ZJZBL, PCTNVCHG, HOLDCOUNT, ZQMC, ZQDM, INDEXNAME, NEWTEXCH,
      } = element;
      // 重仓债券 计算持仓比例之和
      allHoldRatio += isEmpty(ZJZBL) ? 0 : Number(ZJZBL);
      // 占净值比
      const holdRatio = isEmpty(ZJZBL) ? '--' : `${Number(ZJZBL).toFixed(2)}%`;
      // 较上期比例 新增不变直接展示文字 其他情况展示箭头 + 数字
      const compareWithPrevious = ['新增', '不变'].indexOf(PCTNVCHGTYPE) >= 0
        ? PCTNVCHGTYPE
        : `${parseFloat(PCTNVCHG).toFixed(2)}%`;
      // 连续持有期数
      const holdCount = isEmpty(HOLDCOUNT)
        || isEmpty(parseInt(HOLDCOUNT, 10))
        || parseInt(HOLDCOUNT, 10) <= 1
        ? '--'
        : `${parseInt(HOLDCOUNT, 10)}季度`;
      // 债券简称 债券代码 指数 新市场编号
      const bondName = ZQMC;
      const bondCode = ZQDM;
      const indexName = INDEXNAME;
      const newMarketCode = NEWTEXCH;
      temp.push({
        holdRatio,
        compareWithPrevious,
        holdCount,
        bondName,
        bondCode,
        indexName,
        newMarketCode,
        code: bondCode,
      });
    });
    // 取10大重仓
    if (temp.length > 10) {
      temp.splice(10, temp.length - 10);
    }
  }
  return {
    allHoldRatio: isEmpty(allHoldRatio) ? '--' : `${allHoldRatio.toFixed(2)}%`,
    list: temp,
    holdDate: expansion,
    isShowBondsPrice,
  };
}

// 重仓基金列表 ETF联接和FOF基金都是重仓基金 但是数据来源不一样
function handleETFFeederHeavyFundList(AssetAllocation, InverstPosition, expansion) {
  let allHoldRatio = 0;
  let compareWithPrevious = null;
  const temp = [];
  // ETF联接
  let mainData = [];
  if (!isEmpty(AssetAllocation)) {
    mainData = AssetAllocation[expansion];
    if (mainData && mainData.length) {
      allHoldRatio = isEmpty(mainData[0].JJ) ? '--' : `${mainData[0].JJ}`;
      if (mainData[0].JJCHGRT - 0 === 0) {
        compareWithPrevious = '不变';
      } else {
        compareWithPrevious = mainData[0].JJCHGRT || '--';
      }
    }
  }

  if (InverstPosition) {
    temp.push({
      fundName: InverstPosition.ETFSHORTNAME ? InverstPosition.ETFSHORTNAME : '--',
      fundCode: InverstPosition.ETFCODE ? InverstPosition.ETFCODE : '--',
      holdRatio: isEmpty(allHoldRatio) ? '--' : `${allHoldRatio}%`,
      compareWithPrevious: isEmpty(compareWithPrevious) ? '--' : compareWithPrevious,
    });
  }
  return {
    allHoldRatio: isEmpty(allHoldRatio) ? '--' : `${allHoldRatio}%`,
    list: temp,
    holdDate: expansion,
  };
}
function handleFOFHeavyFundList(InverstPosition, expansion) {
  let allHoldRatio = 0;
  const temp = [];
  // FOF基金
  const fundfofs = InverstPosition?.fundfofs || [];
  if (fundfofs && fundfofs.length) {
    fundfofs.forEach((element) => {
      const {
        PCTNVCHGTYPE, ZJZBL, PCTNVCHG, TZJJMC, TZJJDM, FTYPE,
      } = element;
        // 计算持仓比例之和
      allHoldRatio += isEmpty(ZJZBL) ? 0 : Number(ZJZBL);
      // 占净值比
      const holdRatio = isEmpty(ZJZBL) ? '--' : `${Number(ZJZBL).toFixed(2)}%`;
      // 较上期比例 新增不变直接展示文字 其他情况展示箭头 + 数字
      const compareWithPrevious = ['新增', '不变'].indexOf(PCTNVCHGTYPE) >= 0
        ? PCTNVCHGTYPE
        : `${parseFloat(PCTNVCHG).toFixed(2)}%`;
        // 二级分类
      const typeTag = FTYPE || '--';
      // 基金名称代码 指数 新市场编号
      const fundName = TZJJMC;
      const fundCode = TZJJDM;
      temp.push({
        holdRatio,
        compareWithPrevious: isEmpty(compareWithPrevious) ? '--' : compareWithPrevious,
        typeTag,
        fundName,
        fundCode,
      });
    });
    // 取10大重仓
    if (temp.length > 10) {
      temp.splice(10, temp.length - 10);
    }
  }

  return {
    allHoldRatio: (isEmpty(allHoldRatio) ? '--' : `${parseFloat(allHoldRatio).toFixed(2)}%`),
    list: temp,
    holdDate: expansion,
  };
}

// 货币列表
function handleCurrencyList(data) {
  if (!data) return {};
  const mainData = data.FundDistribute || {};
  const getValue = (obj, key) => {
    if (isEmpty(obj) || isEmpty(key)) return '--';
    if (isEmpty(obj[key])) return '--';
    return `${parseFloat(obj[key]).toFixed(2)}%`;
  };
  const temp = [
    {
      date: '30天以内',
      assetsRatio: `${getValue(mainData, 'APCTNC30')}`,
      debtRatio: `${getValue(mainData, 'BPCTNV33')}`,
    },
    {
      date: '30天(含)-60天',
      assetsRatio: `${getValue(mainData, 'T60APCTNV30')}`,
      debtRatio: `${getValue(mainData, 'T60DPCTNV30')}`,
    },
    {
      date: '60天(含)-90天',
      assetsRatio: `${getValue(mainData, 'T90APCTNV60')}`,
      debtRatio: `${getValue(mainData, 'T90DPCTNV60')}`,
    },
  ];
  const { SHOWTYPE } = mainData;
  // 90-120
  if (SHOWTYPE === '1') {
    temp.push(...[
      {
        date: '90天(含)-120天',
        assetsRatio: `${getValue(mainData, 'T120APCTNV90')}`,
        debtRatio: `${getValue(mainData, 'T120DPCTNV90')}`,
      },
      {
        date: '120天(含)-397天',
        assetsRatio: `${getValue(mainData, 'T397APCTNV120')}`,
        debtRatio: `${getValue(mainData, 'T397DPCTNV120')}`,
      },
      {
        date: '总计',
        assetsRatio: `${getValue(mainData, 'ASSETPCTNV')}`,
        debtRatio: `${getValue(mainData, 'DEPOSITPCTNV')}`,
      },
    ]);
  } else {
    // 90-180
    temp.push(...[{
      date: '90天(含)-180天',
      assetsRatio: `${getValue(mainData, 'T180APCTNV90')}`,
      debtRatio: `${getValue(mainData, 'T180DPCTNV90')}`,
    },
    {
      date: '180天(含)-397天',
      assetsRatio: `${getValue(mainData, 'T397APCTNV180')}`,
      debtRatio: `${getValue(mainData, 'T397DPCTNV180')}`,
    },
    {
      date: '总计',
      assetsRatio: `${getValue(mainData, 'ASSETPCTNV')}`,
      debtRatio: `${getValue(mainData, 'DEPOSITPCTNV')}`,
    }]);
  }
  return {
    list: temp,
  };
}

// 分红详情
function handleBonusDetail(data) {
  if (isEmpty(data)) return [];
  const { FHINFO, FCINFO } = data;

  if (FHINFO && FHINFO.length >= 1) {
    const item = FHINFO[0] || {};
    const { FSRQ, FFR, FHFCZ } = item;
    return [
      {
        name: '权益登记日',
        value: isEmpty(FSRQ) ? '--' : FSRQ.replace(/^\d{2}(\d{2})-(\d{2})-(\d{2})/, '$1-$2-$3'),
      },
      {
        name: '分红发放日',
        value: isEmpty(FFR) ? '--' : FFR.replace(/^\d{2}(\d{2})-(\d{2})-(\d{2})/, '$1-$2-$3'),
      },
      {
        name: '每份分红(元)',
        value: isEmpty(FHFCZ) ? '--' : numeral(FHFCZ).format('0.0000'),
      },
    ];
  }
  if (FCINFO && FCINFO.length >= 1) {
    const item = FCINFO[0] || {};
    const { FSRQ, FHFCBZ, FHFCZ } = item;
    return [
      {
        name: '拆分折算日',
        value: isEmpty(FSRQ) ? '--' : FSRQ.replace(/^\d{2}(\d{2})-(\d{2})-(\d{2})/, '$1-$2-$3'),
      },
      {
        name: '类型',
        value: ['106', '206'].indexOf(FHFCBZ) >= 0 ? '份额折算' : '份额分拆',
      },
      {
        name: '比例',
        value: isEmpty(FHFCZ) ? '--' : `约1:${numeral(FHFCZ).format('0.0000')}`,
      },
    ];
  }
  return [];
}

export default {
  handleAssets,
  handleCurrencyAssets,
  handleFundSize,
  handleNetAssetsInfo,
  handleClassification,
  handleIndustry,
  handleTopic,
  handleCouponType,
  handleHeavyStockRatio,
  handleHeavyStockList,
  handleHeavyBondList,
  handleETFFeederHeavyFundList,
  handleFOFHeavyFundList,
  handleCurrencyList,
  handleBonusDetail,
};
